module.exports = __webpack_public_path__ + "media/images/client/favicons/icon-196x196-9aa5702bcf8cc7570fb84848ed20e166.png";